(function($) {
  // smallest jquery plugin of the world ;-)
  $.fn.reverse = [].reverse;
})(window.rossel.jquery);
